var render = function render(){var _vm=this,_c=_vm._self._c;return _c('j-editable-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataSource,"rowNumber":true,"actionButton":true,"rowSelection":true,"maxHeight":400},on:{"valueChange":_vm.handleValueChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }